import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom-v6'
import { Empty, EmptyHeader, EmptyTitle, Skeleton } from '@clouway/ui'

import { ObjectCard } from '../components/ObjectCard'
import { useTrackingObjects } from '../hooks'

export function TrackingObjects() {
  const { t } = useTranslation()
  const { t: tFeature } = useTranslation('feature')
  const { id = '' } = useParams<{ id: string }>()
  const { data: objects, isFetching, isSuccess } = useTrackingObjects(id)

  return (
    <div className="mx-auto flex w-full max-w-2xl flex-col gap-4">
      <h1 className="text-lg font-semibold">{t('trackingObjects.list')}</h1>

      {isFetching && (
        <div className="flex flex-col gap-2">
          <Skeleton className="h-40 w-full" />
          <Skeleton className="h-40 w-full" />
        </div>
      )}

      {isSuccess && !isFetching && objects.length === 0 && (
        <Empty>
          <EmptyHeader>
            <EmptyTitle>{tFeature('trackingObjects.emptyMessage')}</EmptyTitle>
          </EmptyHeader>
        </Empty>
      )}

      {isSuccess &&
        !isFetching &&
        objects.map((object) => <ObjectCard key={object.id} customerId={id} object={object} />)}
    </div>
  )
}
